import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome, FaCommentDots, FaDownload } from 'react-icons/fa';
import '../styles/NotFound.css';

function NotFound() {
    return (
        <div className="notfound-container">
            {/* Starry Night Background */}
            <div className="stars-container">
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
                <div className="star"></div>
            </div>
            
            {/* Moon */}
            <div className="moon"></div>
            
            {/* Main Content */}
            <div className="notfound-content">
                {/* 404 Error Code */}
                <div className="error-code">404</div>
                
                {/* Snoopy Scene */}
                <div className="snoopy-scene">
                    {/* Thought Bubble (appears on hover) */}
                    <div className="thought-bubble">Where's that page? 🤔</div>
                    
                    {/* Snoopy - Classic pose lying on belly, head up */}
                    <div className="snoopy">
                        {/* Z's for sleeping */}
                        <div className="zzz-container">
                            <span className="zzz">Z</span>
                            <span className="zzz">z</span>
                            <span className="zzz">z</span>
                        </div>
                        
                        {/* Snoopy Body */}
                        <div className="snoopy-body">
                            {/* Tall head raised up */}
                            <div className="snoopy-head"></div>
                            
                            {/* Snout pointing left */}
                            <div className="snoopy-snout"></div>
                            
                            {/* Black nose */}
                            <div className="snoopy-nose"></div>
                            
                            {/* Long floppy ear hanging down */}
                            <div className="snoopy-ear"></div>
                            
                            {/* Closed eye (sleeping) */}
                            <div className="snoopy-eye"></div>
                            
                            {/* Black collar/neck area */}
                            <div className="snoopy-belly"></div>
                            
                            {/* Back legs lying flat */}
                            <div className="snoopy-back-legs">
                                <div className="snoopy-back-leg"></div>
                                <div className="snoopy-back-leg"></div>
                            </div>
                            
                            {/* Front paws hanging over edge */}
                            <div className="snoopy-front-paws">
                                <div className="snoopy-paw"></div>
                                <div className="snoopy-paw"></div>
                            </div>
                            
                            {/* Small tail */}
                            <div className="snoopy-tail"></div>
                        </div>
                    </div>
                    
                    {/* Woodstock (little yellow bird) */}
                    <div className="woodstock">
                        <div className="woodstock-body">
                            <div className="woodstock-head"></div>
                            <div className="woodstock-beak"></div>
                            <div className="woodstock-eye"></div>
                            <div className="woodstock-wing"></div>
                            <div className="woodstock-feet">
                                <div className="woodstock-foot"></div>
                                <div className="woodstock-foot"></div>
                            </div>
                        </div>
                    </div>
                    
                    {/* Doghouse */}
                    <div className="doghouse">
                        <div className="doghouse-roof"></div>
                        <div className="doghouse-body">
                            <div className="doghouse-opening"></div>
                        </div>
                    </div>
                </div>
                
                {/* Error Message */}
                <div className="error-message">
                    <h2>Oops! Page Not Found</h2>
                    <p>
                        Looks like Snoopy is dreaming about this page... 
                        but it doesn't exist! Let's get you back on track.
                    </p>
                    
                    {/* Home Button */}
                    <Link to="/" className="home-button">
                        <FaHome />
                        Back to Home
                    </Link>
                    
                    {/* Secondary Links */}
                    <div className="secondary-links">
                        <Link to="/contact" className="secondary-link">
                            <FaCommentDots />
                            Contact Support
                        </Link>
                        <Link to="/downloads" className="secondary-link">
                            <FaDownload />
                            Downloads
                        </Link>
                    </div>
                </div>
            </div>
            
            {/* Ground/Grass */}
            <div className="ground">
                {/* Individual grass blades for effect */}
                {[...Array(20)].map((_, i) => (
                    <div
                        key={i}
                        className="grass-blade"
                        style={{
                            left: `${i * 5 + Math.random() * 3}%`,
                            width: `${3 + Math.random() * 4}px`,
                            height: `${10 + Math.random() * 15}px`,
                            transform: `rotate(${-10 + Math.random() * 20}deg)`
                        }}
                    />
                ))}
            </div>
        </div>
    );
}

export default NotFound;
